import { useMemo, useState } from "react";
import useDocumentMeta from "@/hooks/useDocumentMeta";
import PageHeader from "@/components/feature/PageHeader";
import FilterChips from "@/components/base/FilterChips";
import Pagination from "@/components/base/Pagination";
import EmptyState from "@/components/base/EmptyState";
import ReviewCard from "@/components/feature/ReviewCard";
import { reviewItems, reviewTags } from "@/mocks/content";

const PAGE_SIZE = 5;
const sortOptions = [
  { value: "latest", label: "最新发布" },
  { value: "popular", label: "最受欢迎" },
];

export default function ReviewCategory() {
  useDocumentMeta({
    title: "我的朋友他的妻子 - 精彩剧评",
    description: "收集影视剧观众与评论者的见解与分析。",
    keywords: "我的朋友他的妻子,剧评,影评,观后感,剧情分析",
    canonical: "https://dalian-stay.com.cn/category/reviews",
  });

  const [tag, setTag] = useState("全部");
  const [sort, setSort] = useState("latest");
  const [page, setPage] = useState(1);

  const filtered = useMemo(() => {
    const list = reviewItems.filter((item) => tag === "全部" || item.tags.includes(tag));
    return [...list].sort((a, b) =>
      sort === "popular" ? b.popularity - a.popularity : b.date.localeCompare(a.date),
    );
  }, [tag, sort]);

  const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  const currentPage = Math.min(page, totalPages);
  const paged = filtered.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);

  const handleTag = (value: string) => {
    setTag(value);
    setPage(1);
  };
  const handleSort = (value: string) => {
    setSort(value);
    setPage(1);
  };

  return (
    <>
      <PageHeader
        title="精彩剧评"
        subtitle="从叙事结构到人物塑造，从镜头语言到原创配乐，汇聚影评人与观众的多元解读。"
        crumbs={[{ label: "首页", to: "/" }, { label: "精彩剧评" }]}
      />

      <div className="mx-auto w-full max-w-content px-4 py-8 md:px-6 md:py-12">
        <div className="mb-8 flex flex-col gap-4 rounded-lg border border-background-300 bg-background-50 p-4 md:flex-row md:items-center md:justify-between">
          <div className="flex items-start gap-3">
            <span className="mt-1 shrink-0 text-sm text-foreground-500">
              <i className="ri-price-tag-3-line mr-1"></i>
              分类
            </span>
            <FilterChips options={reviewTags} value={tag} onChange={handleTag} />
          </div>
          <label className="flex shrink-0 items-center gap-2 text-sm text-foreground-600">
            <i className="ri-sort-desc"></i>
            <select
              value={sort}
              onChange={(e) => handleSort(e.target.value)}
              className="rounded-md border border-background-300 bg-background-50 px-3 py-1.5 text-sm text-foreground-800 outline-none focus:border-primary-400"
            >
              {sortOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </label>
        </div>

        {paged.length === 0 ? (
          <EmptyState message="暂无剧评内容" icon="ri-chat-quote-line" />
        ) : (
          <>
            <div className="flex flex-col gap-4">
              {paged.map((item) => (
                <ReviewCard key={item.id} item={item} />
              ))}
            </div>
            <Pagination page={currentPage} totalPages={totalPages} onChange={setPage} />
          </>
        )}
      </div>
    </>
  );
}